export const orderedServices = {
  header: {
    service: "Service",
    order: "Auftrag",
    hall: "Halle",
    stand: "Stand",
    total: "Gesamtbetrag",
  },
  status: {
    edited: "bearbeitet",
    cancelRequest: "Stornierung beantragt",
    cancelled: "storniert",
  },
  items: {
    orderer: "Besteller",
    customerInformation: "Kundeninformation",
  },
  noData: "Es sind keine gebuchten Serviceleistungen vorhanden.",
}
